import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-request-sent-dialog',
    templateUrl: './request-sent-dialog.html'
})
export class RequestSentDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<RequestSentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/request-sent-dialog/request-sent-dialog.ts